<ion-row
  data-cy="sortable-section-header-row"
  class="sortable-section-header-row"
>
  <!-- SECTION TITLE -->
  <ion-col
    *ngIf="showTitle"
    data-cy="sortable-section-title-column"
    size="{{ sectionTitleSize }}"
  >
    <ion-label data-cy="sortable-section-title-text" class="title-text">
      <span [innerHTML]="sectionTitle"></span>
    </ion-label>
  </ion-col>

  <!-- SECTION HEADERS (FOR SORTING) -->
  <ng-container *ngIf="sectionHeaders">
    <ng-container
      *ngFor="
        let sectionHeader of sectionHeaders;
        index as i;
        trackBy: trackItem
      "
    >
      <ion-col
        *ngIf="sectionHeader?.displayText"
        data-cy="sortable-section-header-column"
        size="{{ sectionHeader?.size }}"
        offset="{{ sectionHeader?.offset }}"
      >
        <ion-label
          [attr.data-cy]="
            'sortable-section-header-' +
            sectionHeader?.headerName?.toLowerCase() +
            '-label'
          "
          class="header-text"
        >
          {{ sectionHeader?.displayText | translate }}
        </ion-label>
      </ion-col>
    </ng-container>
  </ng-container>
</ion-row>

<!-- DATA -->
<ng-content></ng-content>

<!-- NO DATA -->
<ion-row
  *ngIf="!hasSectionData"
  data-cy="sortable-section-no-data-row"
  class="sortable-section-data-row"
>
  <ion-col data-cy="sortable-section-no-data-column" size="12">
    <ion-item
      data-cy="sortable-section-no-data-section"
      class="sortable-section-data-item no-data"
      detail="false"
      lines="none"
    >
      <ion-label data-cy="sortable-section-no-data-text">
        {{ noDataText }}
      </ion-label>
    </ion-item>
  </ion-col>
</ion-row>
